import type { LanguageIsoCodeEnum } from "@iot-platform/core";
import { BaseViewModel, LanguageUpdateUseCase } from "@iot-platform/core";
import { inject, injectable } from "inversify";
import { makeObservable } from "mobx";

@injectable()
export class SiderMenuViewModel extends BaseViewModel {
    constructor(
        @inject(LanguageUpdateUseCase)
        private readonly languageUpdateUseCase: LanguageUpdateUseCase,
    ) {
        super();
        makeObservable(this);
    }

    async updateLanguage(language: LanguageIsoCodeEnum): Promise<boolean> {
        const updateLanguageResult =
            await this.languageUpdateUseCase.execute(language);

        return updateLanguageResult.isOk();
    }
}
